import { Download, FileSignature } from 'lucide-react';
import type { VisitSummary } from '../lib/types';

export function VisitBadges({ visit }: { visit: VisitSummary }) {
  return (
    <span className="flex items-center gap-1.5">
      {visit.ndaSigned && (
        <span
          title="Signed the NDA"
          className="flex items-center gap-0.5 rounded-sm bg-emerald-50 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700"
        >
          <FileSignature className="h-3 w-3" /> NDA
        </span>
      )}
      {visit.downloads.length > 0 && (
        <span
          title={`${visit.downloads.length} download(s)`}
          className="flex items-center gap-0.5 rounded-sm bg-accent/10 px-1.5 py-0.5 text-[10px] font-semibold text-accent"
        >
          <Download className="h-3 w-3" /> {visit.downloads.length}
        </span>
      )}
    </span>
  );
}
